let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kVzfx")]).then(() => parcelRequire('kczS3'));